import React, { useState } from 'react';
import { Button, FlexBox, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';
import { CombinedProject } from '../hooks/useCombinedProjects';
import { CollaborationRequestCard } from './CollaborationRequestCard';
import { JobCard } from './JobCard';
import { NonWorkEntityRequestCard } from './NonWorkEntityRequestCard';
import { ProjectsRequestCard } from './ProjectsRequestCard';

const numberOfPastRequestsToShow = 5;

export interface ProjectsProps {
    requests: CombinedProject[];
}

const PastProjects: React.FC<ProjectsProps> = ({ requests }: ProjectsProps) => {
    const [allRequestsExpanded, setAllRequestsExpanded] = useState(false);

    return (
        <>
            <FlexBox flexDirection="column" gap="between-subsections">
                {requests
                    .slice(0, allRequestsExpanded ? requests.length : numberOfPastRequestsToShow)
                    .map((r) => {
                        return r.type === 'Legacy' ? (
                            <NonWorkEntityRequestCard key={r.value.publicId} request={r.value} />
                        ) : r.type === 'Collaboration' ? (
                            <CollaborationRequestCard key={r.value.url} {...r.value} />
                        ) : r.type === 'Request' ? (
                            <JobCard key={r.value.publicId} request={r.value} />
                        ) : (
                            <ProjectsRequestCard key={r.value.id} {...r.value} />
                        );
                    })}
            </FlexBox>
            {!allRequestsExpanded && requests.length > numberOfPastRequestsToShow && (
                <FlexBox
                    alignItems="center"
                    justifyContent="center"
                    marginTop="between-subsections"
                >
                    <Button skin="secondary" onClick={() => setAllRequestsExpanded(true)}>
                        {__('View all past projects')}
                    </Button>
                </FlexBox>
            )}
        </>
    );
};

export { PastProjects };
